/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/ToHex.ts
 * @create:      2025-06-27 10:43:28.149
 * @modify:      2025-07-11 21:19:12.814
 * @version:     6.0.0
 * @times:       6
 * @lines:       53
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Converts a number to its hexadecimal string representation.
 *
 * @param number - The number to convert to hexadecimal.
 * @param len - Optional. The minimum length of the resulting string. If specified and the hexadecimal string is shorter, it will be left-padded with zeros.
 * @returns The hexadecimal string representation of the input number, padded with zeros to the specified length if provided.
 * 
 * @since 4.0.0
 * @version 2025-06-27
 */
export function ToHex(number: number, len?: number): string {
    const isNegative = number < 0;
    let absHex = Math.abs(number).toString(16);

    if (len !== undefined && len > absHex.length) {
        absHex = absHex.padStart(len, "0");
    }

    return isNegative ? "-" + absHex : absHex;
}
